import { getInitialState, getPath } from "../../utils";
import ActionTypes from "../actions/ActionTypes";

const initialState = {
  riderOffers: [],
  activeFilters: {},
};

export default function (state = initialState, action) {
  switch (action.type) {
    case ActionTypes.SET_RIDER_OFFERS:
      return setRiderOffers(state, action);
    case ActionTypes.RESET_STATE_RIDER_OFFERS:
      return resetState(state, action);
    case ActionTypes.SET_RIDER_OFFERS_ACTIVE_FILTERS:
      return setActiveFilters(state, action);
    default:
      return state;
  }
}
const setRiderOffers = (state, action) => {
  return {
    ...state,
    riderOffers: getPath(action.payload, "data", []),
  };
};

const resetState = (state, action) => {
  if (action.payload.state) {
    return {
      ...state,
      [action.payload.state]: getInitialState(
        initialState,
        action.payload.state
      ),
    };
  } else {
    return initialState;
  }
};

const setActiveFilters = (state, action) => {
  return {
    ...state,
    activeFilters: action.payload,
  };
};
